export default "__VITE_ASSET__BrcM0lXI__"